import { iosNotificationInterruptionLevelEnum } from '@/modules/campaign-manage/enum/IosNotificationInterruptionLevelEnum'
import { voucherTypes } from '@/modules/campaign-manage/enum/VoucherTypesEnum'
import { voucherPositions } from '@/modules/campaign-manage/enum/VoucherPositionsEnum'
import { subscriptionTypes } from '@/modules/campaign-manage/enum/InAppTypesEnum'

const defaultMessages = Object.freeze({
  1: {
    push_category_id: null,
    push_title: '',
    push_text: '',
    push_picture: null,
    push_picture_type: null,
    push_action: {
      action: '',
      url: '',
      deeplink: '',
      javascript: ''
    },
    push_buttons: {},
    payload_add: [],
    push_interruption_level: iosNotificationInterruptionLevelEnum.ACTIVE,
    voucher_code_enabled: voucherTypes.NONE,
    voucher_code_position: voucherPositions.BOTTOM
  },
  2: {
    push_category_id: null,
    push_title: '',
    push_text: '',
    push_picture: null,
    push_picture_type: null,
    push_action: {
      action: ''
    },
    push_buttons: {},
    payload_add: [],
    voucher_code_enabled: voucherTypes.NONE,
    voucher_code_position: voucherPositions.BOTTOM
  },
  3: {
    push_category_id: null,
    push_title: '',
    push_text: '',
    push_picture: null,
    push_picture_type: null,
    push_icon: null,
    push_action: {
      action: 'url',
      url: ''
    },
    push_buttons: {},
    voucher_code_enabled: voucherTypes.NONE,
    voucher_code_position: voucherPositions.BOTTOM
  },
  4: {
    inapp_type: 0,
    inapp_orientation: 0,
    inapp: {
      html: null,
      editor: {
        sequence: ['image', 'title', 'text', 'buttons', 'inline-preferences'],
        main_text: '',
        title: '',
        image: '',
        image_checkbox: 1,
        image_height: '',
        button0: {
          enabled: 'on',
          text: '',
          action: 'none',
          special: 'none',
          trigger: 'none',
          deeplink: null,
          url: null,
          trigger_event: null,
          add_to_list: null,
          subscribe_to: null,
          set_attribute: {
            name: null,
            value: null
          }
        },
        button1: {
          enabled: 'off',
          text: '',
          action: 'none',
          special: 'none',
          trigger: 'none',
          deeplink: null,
          url: null,
          trigger_event: null,
          add_to_list: null,
          subscribe_to: null,
          set_attribute: {
            name: null,
            value: null
          }
        },
        inline_preference: {
          subscription: subscriptionTypes.EMAIL,
          enabled: 0,
          terms_enabled: 0,
          contact_field: 0,
          contact_field_placeholder: '',
          terms_text: null,
          opt_in: null,
          button: null
        },
        color_background: '#efefef',
        color_border: '',
        color_border_radius: 12,
        color_title: '#1d87c8',
        color_text: '#1d87c8',
        color_button_0_text: '#ffffff',
        color_button_0_background: '#45818e',
        color_button_0_border: '',
        color_button_1_text: '#ffffff',
        color_button_1_background: '#45818e',
        color_button_1_border: '',
        color_container: '#000000',
        opacity_container: '',
        color_inline_button_background: '#45818e',
        color_inline_button_text: '#ffffff',
        color_inline_button_border: '',
        color_inline_text: '#000000',
        color_inline_checkbox: '#1d87c8'
      },
      placeholder: {
        portrait: {
          background: ''
        },
        landscape: {
          background: ''
        },
        position: 'top',
        action: 'none', // url, deeplink, dimiss
        url: null,
        special: 'none', // selected, set_attribute, add_to_list, subscribe_to
        trigger: 'none', // None(null), trigger_event
        set_attribute: {
          name: null,
          value: null
        },
        add_to_list: null,
        subscribe_to: null,
        trigger_event: null
      },
      creatives: {
        portrait: {
          creative_0: { background_file: '', height: 50, min_width: 0 }
        },
        landscape: {
          creative_1: { background_file: '', height: 32, min_width: 0 }
        }
      },
      buttons: {
        button_0: {
          action: null,
          special: null,
          trigger: null,
          deeplink: null,
          url: null,
          trigger_event: null,
          add_to_list: null,
          set_attribute: {
            name: null,
            value: null
          },
          portrait: { background_file: '' },
          landscape: { background_file: '' }
        }
      },
      native: {
        payload_type: 'raw',
        payload: {
          form: '',
          formSettings: {},
          formTemplate: '',
          formValues: {},
          json: [],
          raw: ''
        }
      }
    }
  },
  5: {
    onsite_type: 1,
    push_silent: 0,
    push_title: '',
    push_text: '',
    push_icon: null,
    push_action: {
      action: 'none', // none, url, deeplink, inapp, javascript
      url: '',
      deeplink: '',
      javascript: ''
    },
    onsite: {
      popup: {
        inline_preference: {
          subscription: subscriptionTypes.EMAIL,
          enabled: 0,
          opt_in: null,
          button: null,
          terms_enabled: 0,
          contact_field: 0,
          contact_field_placeholder: '',
          terms_text: null,
          age_confirmation_text: null,
          ipc_sequence: [
            'age_confirmation',
            'terms',
            'opt_in',
            'contact_field',
            'button'
          ]
        },
        email_checkbox: 0,
        email_subscription: 1,
        email_submit: {
          action: 'standard', // dismiss, standard, javascript
          javascript: null
        },
        image_checkbox: 1,
        title_checkbox: 1,
        text_checkbox: 1,
        footer_checkbox: 0,
        image_type: 'none',
        image: null,
        image_url: null,
        image_link: null,
        image_height: null,
        title: '',
        main_text: '',
        footer: null,
        message_size: { width: 500, scroll: 'page' }, // content
        button0: {
          enabled: 1,
          text: 'OK',
          action: 'none', // none, dismiss, submit, url, javascript
          url: '',
          url_blank: 0,
          javascript: '',
          special: 'none', // "", set_attribute, add_to_list,
          add_to_list: '',
          set_attribute: {
            name: '',
            value: ''
          },
          special_2: '', // "", subscribe_to
          subscribe_to: '',
          trigger: '', // "", trigger_event
          trigger_event: ''
        },
        button1: {
          enabled: 0,
          text: 'Cancel',
          action: 'none', // none, dismiss, submit, url, javascript
          url: '',
          url_blank: 0,
          javascript: '',
          special: 'none', // "", set_attribute, add_to_list,
          add_to_list: '',
          set_attribute: {
            name: '',
            value: ''
          },
          special_2: '', // "", subscribe_to
          subscribe_to: '',
          trigger: '', // "", trigger_event
          trigger_event: ''
        },
        style: {
          color_backdrop: '#000000',
          opacity_backdrop: 40,
          color_background: '#ffffff',
          opacity_background: 100,
          color_title: '#545454',
          color_text: '#545454',
          color_button_0_background: '#3085d6',
          color_button_0_text: '#ffffff',
          color_button_1_background: '#aaaaaa',
          color_button_1_text: '#ffffff',
          color_footer: '#545454',
          color_footer_separator: '#eeeeee',
          color_inline_button_background: '#3085d6',
          color_inline_button_text: '#ffffff',
          color_inline_button_border: '',
          color_inline_text: '#000000',
          color_inline_checkbox: '#1d87c8'
        }
      },
      native: {
        payload_type: 'raw',
        payload: {
          form: '',
          formSettings: {},
          formTemplate: '',
          formValues: {},
          json: [],
          raw: ''
        }
      }
    }
  },
  6: {
    inbox_type: 0,
    push_title: '',
    push_text: '',
    push_picture: null,
    push_picture_type: null,
    push_action: {
      action: ''
    },
    inbox_style: {
      bg: '',
      title_bg: ''
    },
    push_buttons: {},
    payload_add: [],
    voucher_code_enabled: voucherTypes.NONE,
    voucher_code_position: voucherPositions.BOTTOM,
    url: null,
    push_icon: null
  },
  7: {
    email_addressable: null,
    email_subject: '',
    email_from_address: null,
    email_from_name: null,
    email_reply_to_address: null,
    email_reply_to_name: null,
    email_unsubscribe: 1,
    email_template: null,
    email_type: 1,
    email_html: '',
    email_unsubscribe_header_behaviour: 0,
    email: {
      attachments: [
        {
          file: '',
          name: null
        }
      ]
    }
  },
  8: {
    webhook: {
      url: '',
      request_body_data: {
        post: [],
        raw: '',
        json: []
      },
      get_params: [],
      request_headers: [],
      request_body_type: 'raw'
    }
  },
  9: {
    sms: {
      from: '',
      text: '',
      rcs: false
    },
    sms_unsubscribe: 0,
    sms_unsubscribe_with_reply: 0,
    sms_unsubscribe_language: '',
    voucher_code_enabled: voucherTypes.NONE,
    voucher_code_position: voucherPositions.BOTTOM
  },
  10: {
    facebook: {
      title: '',
      subtitle: '',
      image_url: '',
      default_action: {
        type: 'web_url',
        url: ''
      }
    }
  },
  11: {
    whatsapp: {
      template_category: '',
      template_name: '',
      text: '',
      params: {}
    }
  },
  12: {
    workflow_id: null
  }
})

export { defaultMessages }



// WEBPACK FOOTER //
// ./src/modules/campaign-manage/enum/DefaultMessages.js